"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var Info_14px_small_1 = require("../../../img/Info_14px_small");
var ModelResultSlice_1 = require("../../../store/slice/ModelResultSlice");
var PredictiveModelSlice_1 = require("../../../store/slice/PredictiveModelSlice");
var ModelResultThunk_1 = require("../../../store/thunk/ModelResultThunk");
var styles = require("../../../styles/ModelResultStyles");
var ConfusionMatricesUtils_1 = require("../../../util/ConfusionMatricesUtils");
var TestIds_1 = require("../../../util/TestIds");
var ValidatorUtils_1 = require("../../../util/ValidatorUtils");
var ModelMetrics_1 = require("../type/ModelMetrics");
var ModelResultThresholdController = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var trainingJob = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectJob);
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), sessionThreshold = _a.sessionThreshold, originalThreshold = _a.originalThreshold, thresholdStatus = _a.thresholdStatus, confusionMatricesClassification = _a.confusionMatricesClassification, thresholdOptimization = _a.thresholdOptimization;
    var _b = React.useState(originalThreshold || 0), sliderValue = _b[0], setSliderValue = _b[1];
    var _c = React.useState(sliderValue.toFixed(3)), sliderTextValue = _c[0], setSliderTextValue = _c[1];
    var _d = React.useState(''), costRatio = _d[0], setCostRatio = _d[1];
    var _e = React.useState(false), didMount = _e[0], setDidMount = _e[1];
    var sliderTextRef = React.createRef();
    var costRatioTextRef = React.createRef();
    // This hook only triggers once when component initially mounted
    // Used to set threshold to its initial value
    React.useEffect(function () {
        onThresholdReset();
        setDidMount(true);
    }, [didMount]);
    // This hook triggers when slider changed and dispatch threshold update
    // action
    React.useEffect(function () {
        var timeout = setTimeout(function () {
            dispatch((0, ModelResultSlice_1.updateSessionThreshold)(sliderValue));
        }, 100);
        return function () { return clearTimeout(timeout); };
    }, [sliderValue]);
    // This hook only triggers after component mounted.
    // This is used for the following session threshold update
    React.useEffect(function () {
        if (didMount && (0, ValidatorUtils_1.isValidObject)(sessionThreshold)) {
            onSliderChange(sessionThreshold);
        }
    }, [didMount, sessionThreshold]);
    var onSliderChange = function (value) {
        var roundedValue = Math.round(value * 1000) / 1000;
        setSliderValue(roundedValue);
        setSliderTextValue(roundedValue.toFixed(3));
    };
    var onSliderTextBoxBlur = function (value) {
        var parsedValue = parseFloat(value);
        if (isNaN(parsedValue) || parsedValue < 0 || parsedValue > 1) {
            setSliderTextValue(sliderValue.toFixed(3));
            return;
        }
        onSliderChange(parsedValue);
        dispatch((0, ModelResultSlice_1.setThresholdOptimization)(ModelMetrics_1.ThresholdOptimizeCategory.CUSTOM));
    };
    var onSliderKeyPress = function (event) {
        var _a;
        if (event.key === 'Enter') {
            (_a = sliderTextRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    };
    var onOptimizationChange = function (val) {
        var category = val;
        dispatch((0, ModelResultSlice_1.setThresholdOptimization)(category));
        var threshold = (0, ConfusionMatricesUtils_1.getDefaultThreshold)(props.confusionMatrices, confusionMatricesClassification, category);
        if (threshold !== null) {
            onSliderChange(threshold);
        }
    };
    var isCostRatioValid = function () {
        if (costRatio === '')
            return true;
        var parsedRatio = parseFloat(costRatio);
        return !isNaN(parsedRatio) && parsedRatio >= 0;
    };
    var textFieldMessage = function () {
        if (isCostRatioValid())
            return null;
        return Localize_1.Messages.costRatioValidation();
    };
    var onCostRatioBlur = function (value) {
        if (!isCostRatioValid())
            return;
        if (value === '')
            return;
        var parsedRatio = parseFloat(value);
        var result = (0, ConfusionMatricesUtils_1.getOptimalThresholdByCostRatio)(props.confusionMatrices, parsedRatio);
        if (result) {
            onSliderChange(result.threshold);
            dispatch((0, ModelResultSlice_1.setThresholdOptimization)(ModelMetrics_1.ThresholdOptimizeCategory.CUSTOM));
        }
    };
    var onCostRatioKeyPress = function (event) {
        var _a;
        if (event.key === 'Enter') {
            (_a = costRatioTextRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    };
    var onThresholdReset = function () {
        if (thresholdStatus === ModelMetrics_1.THRESHOLD_STATUS.UPDATING) {
            return;
        }
        if (sessionThreshold !== originalThreshold) {
            dispatch((0, ModelResultSlice_1.resetSessionThreshold)());
        }
    };
    var onThresholdResetKeyPress = function (event) {
        if (event.key === 'Enter') {
            onThresholdReset();
        }
    };
    var onThresholdApplied = function () {
        if (sessionThreshold !== originalThreshold && trainingJob.einsteinRunId && (0, ValidatorUtils_1.isValidObject)(sessionThreshold)) {
            dispatch((0, ModelResultThunk_1.updateModelThreshold)({
                // TODO: a typo here and property name should be runId
                // and will correct after next protobuf update
                storyId: trainingJob.einsteinRunId,
                classificationThreshold: {
                    type: 'Binary',
                    value: sessionThreshold,
                },
            }));
        }
    };
    var onThresholdAppliedKeyPress = function (event) {
        if (event.key === 'Enter') {
            onThresholdApplied();
        }
    };
    var renderThresholdDescription = function (message) {
        return React.createElement("div", { className: styles.ThresholdDescription }, message);
    };
    var renderThresholdOptimization = function () {
        var header = React.createElement("div", { className: styles.ThresholdOptimizationHeader }, Localize_1.Messages.thresholdOptimizationTitle());
        var description = renderThresholdDescription(Localize_1.Messages.thresholdOptimizationDescription());
        var listItems = React.createElement(widgets_1.List, { items: Object.values(ModelMetrics_1.ThresholdOptimizeCategory).map(function (n) { return ({ value: n }); }) });
        return (React.createElement(widgets_1.SingleSelectDropdown, { label: header, list: listItems, onChange: onOptimizationChange, type: widgets_1.DropdownButtonType.Outline, value: thresholdOptimization, testId: TestIds_1.MODEL_RESULT_THRESHOLD_EVALUATION_OPTIMIZATION_CONTROL_TEST_ID, message: description, disabled: thresholdStatus === ModelMetrics_1.THRESHOLD_STATUS.UPDATING }));
    };
    var renderThresholdSlider = function () {
        var renderLabelSection = function () { return (React.createElement("div", { className: styles.ThresholdSliderHeader },
            React.createElement("div", null, Localize_1.Messages.thresholdText()),
            React.createElement(widgets_1.TextFieldWidget, { ref: sliderTextRef, label: "", onBlur: function (e) { return onSliderTextBoxBlur(e.target.value); }, onChange: function (e) { return setSliderTextValue(e.target.value); }, onKeyPress: function (e) { return onSliderKeyPress(e); }, testId: TestIds_1.MODEL_RESULT_THRESHOLD_EVALUATION_SLIDER_TEXTBOX_TEST_ID, style: { width: 50 }, value: sliderTextValue, disabled: thresholdStatus === ModelMetrics_1.THRESHOLD_STATUS.UPDATING }))); };
        var renderSlider = function () { return (React.createElement(widgets_1.SliderWidget, { min: 0, max: 1, value: sliderValue, onChange: function (value) {
                onSliderChange(value);
                dispatch((0, ModelResultSlice_1.setThresholdOptimization)(ModelMetrics_1.ThresholdOptimizeCategory.CUSTOM));
            }, style: { padding: 0, marginLeft: '-11px', marginRight: '-10px' }, testId: TestIds_1.MODEL_RESULT_THRESHOLD_EVALUATION_SLIDER_CONTROL_TEST_ID, disabled: thresholdStatus === ModelMetrics_1.THRESHOLD_STATUS.UPDATING })); };
        return (React.createElement(React.Fragment, null,
            renderLabelSection(),
            renderSlider()));
    };
    var renderActionSection = function () {
        return (React.createElement("div", { className: styles.ThresholdActionSection },
            React.createElement("div", { className: styles.ThresholdActionButton, "data-tb-test-id": TestIds_1.MODEL_RESULT_THRESHOLD_APPLY_TEST_ID, onClick: function () { return onThresholdApplied(); }, onKeyPress: function (e) { return onThresholdAppliedKeyPress(e); }, role: "button", tabIndex: 0 }, Localize_1.Messages.applyThresholdText()),
            React.createElement("div", { className: styles.ThresholdActionButton, "data-tb-test-id": TestIds_1.MODEL_RESULT_THRESHOLD_RESET_TEST_ID, onClick: function () { return onThresholdReset(); }, onKeyPress: function (e) { return onThresholdResetKeyPress(e); }, role: "button", tabIndex: 0 }, Localize_1.Messages.resetThresholdText())));
    };
    var renderCostRatio = function () {
        var renderHeader = function () {
            return (React.createElement("div", { className: styles.ThresholdCostRatioHeader },
                Localize_1.Messages.costRatioTitle(),
                React.createElement(widgets_1.Tooltip, { getContent: function () { return React.createElement("div", null, Localize_1.Messages.costRatioTooltip()); } },
                    React.createElement("div", { className: styles.ThresholdCostRatioInfoPopover },
                        React.createElement(Info_14px_small_1.InfoSmall, null)))));
        };
        var renderTextBox = function () {
            return (React.createElement(widgets_1.TextFieldWidget, { label: "", ref: costRatioTextRef, message: textFieldMessage(), onChange: function (e) { return setCostRatio(e.target.value); }, onBlur: function (e) { return onCostRatioBlur(e.target.value); }, onKeyPress: function (e) { return onCostRatioKeyPress(e); }, placeholder: Localize_1.Messages.costRatioNoValue(), testId: TestIds_1.MODEL_RESULT_THRESHOLD_EVALUATION_COST_RATIO_TEST_ID, valid: isCostRatioValid(), value: costRatio, className: styles.ThresholdCostRatioTextBox, style: { width: '100%' }, disabled: thresholdStatus === ModelMetrics_1.THRESHOLD_STATUS.UPDATING }));
        };
        var renderDescription = function () { return renderThresholdDescription(Localize_1.Messages.costRatioDescription()); };
        return (React.createElement(React.Fragment, null,
            renderHeader(),
            renderTextBox(),
            renderDescription()));
    };
    return (React.createElement("div", { className: styles.ThresholdControllerContainer, "data-tb-test-id": TestIds_1.MODEL_RESULT_THRESHOLD_CONTROLLER_TEST_ID },
        renderThresholdOptimization(),
        renderThresholdSlider(),
        renderActionSection(),
        renderCostRatio()));
};
exports.default = ModelResultThresholdController;
//# sourceMappingURL=ModelResultThresholdController.js.map